import React, { useState, useCallback } from 'react';
import proptypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Drawer, IconButton } from '@one-thd/sui-atomic-components';
import { Email } from '@one-thd/sui-icons';
import { EmailListDrawerBody } from '../ListSettings/drawerBodies/EmailListDrawerBody';
import { ShareListDrawerBody } from '../ListSettings/drawerBodies/ShareListDrawerBody';
import ShareAction from './ShareAction';

const { string, bool, shape } = proptypes;

export const EmailList = ({ listId, iconSize, shareIcon, list }) => {
  const [open, setOpen] = useState(false);
  const [menuName, setMenuName] = useState(shareIcon ? 'Share List' : 'Email List');
  const setShareListDrawer = useCallback(() => { }, []);
  const setMainMenuDrawer = useCallback(() => { }, []);

  const handleOpen = () => {
    LIFE_CYCLE_EVENT_BUS.trigger('product-list.open-share-drawer', {});
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setMenuName(shareIcon ? 'Share List' : 'Email List');
  };
  // Intentionally left as a no-op.
  // EmailList itself does not manage any save/persist behavior, but ShareListDrawerBody
  // expects an onSave prop and may invoke it after completing its own internal save logic.
  // Providing a no-op here documents that no additional action is required at this level.
  const handleSave = () => {};

  return (
    <div className="sui-flex sui-justify-center" data-component="email-list">
      {shareIcon ? (
        <ShareAction onClick={handleOpen} iconSize={iconSize} />
      ) : (
        <IconButton
          iconSize={iconSize}
          icon={Email}
          alt="Email"
          aria-label="Email"
          onClick={handleOpen}
        />
      )}
      {/*
        The Drawer renders through a React portal to document.body. When this drawer
        is opened from a themed experience (e.g. the B2B homepage Lists component),
        the themed --sui-palette-* custom properties set on an ancestor cascade into
        the portaled drawer and incorrectly theme it. Setting data-sui-palette="light"
        on the drawer's root re-declares the default light palette on the drawer
        element itself, overriding the inherited theme. See WOR2-865.
      */}
      <Drawer open={open} onClose={handleClose} DrawerRootProps={{ 'data-sui-palette': 'light' }}>
        {shareIcon ? (
          <ShareListDrawerBody
            list={list || { id: listId }}
            onClose={handleClose}
            onSave={handleSave}
            menuName={menuName}
            setMainMenuDrawer={setMainMenuDrawer}
            setShareListDrawer={setShareListDrawer}
            setMenuName={setMenuName}
            hideBackButton
          />
        ) : (
          <EmailListDrawerBody
            listId={listId}
            onClose={handleClose}
            menuName="Email List"
            hideBackButton
          />
        )}
      </Drawer>
    </div>
  );
};

EmailList.propTypes = {
  listId: string,
  iconSize: string,
  shareIcon: bool,
  list: shape({
    id: string,
    name: string,
    listAccessType: string
  }),
};

EmailList.defaultProps = {
  listId: null,
  iconSize: 'small',
  shareIcon: false,
  list: null,
};

EmailList.displayName = 'EmailList';

EmailList.dataModel = extend(
  EmailListDrawerBody,
  ShareListDrawerBody
);
